/**
 * Moonpage 品牌 - Welfare 页面配置
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

const primaryGradient = brandTheme.primaryGradient || 'linear-gradient(90deg, #8DB8FF 0%, #5E79F6 100%)'

export const theme = {
  btnBg: brandTheme.primaryColor,
  btnText: brandTheme.textInverse,
  coinsColor: brandTheme.primaryColor,
  coinsGradient: primaryGradient,
  actionGradient: brandTheme.primaryGradient,
  checkinBtnGradient: primaryGradient,
} as const

export const resources = {
  homeBg: '/images/moonpage/home-bg.webp',
  welfareGold: '/images/moonpage/welfare-gold.png',
  welfareBox: '/images/moonpage/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
